// import React, { useState } from 'react';

// const ContactForm = () => {
//   const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
//   const [submitted, setSubmitted] = useState(false);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // In real-world: send to backend or email service
//     setSubmitted(true);
//   };

//   return (
//       <section id="contact" className="overflow-hidden py-20 px-6 text-center bg-gradient-to-tr from-pink-100 to-sky-100">
//       <h2 className="text-4xl font-bold mb-2">Start Your Career Planning Journey Today</h2>
//       <p className="text-lg text-indigo-600 font-semibold mb-4">Book your consultation now</p>
//       <p className="max-w-xl mx-auto text-gray-700 mb-4">
//         Get in touch for personalized consultations or queries. Our experts are ready to guide you at every stage of your career journey.
//       </p>
//       <p className="text-lg font-semibold text-gray-800 mb-2">
//         📞 Call us: <a href="tel:+919920405421" className="text-indigo-600 hover:underline">+91 9920405421</a>
//       </p>
//       <p className="text-md text-gray-700 mb-10">
//         📧 Email: <a href="mailto:connect@systematiccareerplanner.com" className="text-indigo-600 hover:underline">connect@systematiccareerplanner.com</a>
//       </p>
//       {!submitted ? (
//       <form onSubmit={handleSubmit} className="relative max-w-lg mx-auto bg-white/80 rounded-3xl shadow-xl p-8 space-y-4">
//         <input type="text" name="name" placeholder="Your Name" required className="w-full px-4 py-3 rounded-lg border focus:ring focus:ring-indigo-200" onChange={handleChange}/>
//         <input type="tel" name="phone" placeholder="Your Phone Number" required pattern="[0-9]{10}" title="Enter a valid 10-digit phone number" className="w-full px-4 py-3 rounded-lg border focus:ring focus:ring-indigo-200" onChange={handleChange}/>
//         <input type="email" name="email" placeholder="Your Email" required className="w-full px-4 py-3 rounded-lg border focus:ring focus:ring-indigo-200" onChange={handleChange}/>
//         <textarea name="message" placeholder="Your Message" rows="4" required className="w-full px-4 py-3 rounded-lg border focus:ring focus:ring-indigo-200" onChange={handleChange}></textarea>
//         <button type="submit" className="w-full py-3 rounded-lg bg-indigo-600 text-white hover:scale-105 transition">
//           Send Message 🚀
//         </button>
//       </form>
//       ) : (
//           <div className="bg-green-100 text-green-700 p-6 rounded shadow">Thanks! We'll get back to you soon.</div>
//         )}
//     </section>
//   );
// };

// export default ContactForm;

import React, { useState } from 'react';

// Use localhost PHP server during development, and relative path in production (Hostinger)
const API_URL = process.env.NODE_ENV === 'production' ? '/contact.php' : 'http://localhost:8000/contact.php';

const ContactForm = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '', botcheck: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'contact',
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          botcheck: formData.botcheck,
        }),
      });

      const data = await res.json();
      if (res.ok && data.success) {
        setSubmitted(true);
      } else {
        setError(data.error || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }

    // Previous Web3Forms submission logic (commented out for reference):
    // const res = await fetch("https://api.web3forms.com/submit", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({
    //     access_key: WEB3FORMS_KEY,
    //     subject: `New Contact Form Submission from ${formData.name}`,
    //     from_name: "Systematic Career Planner Website",
    //     name: formData.name,
    //     email: formData.email,
    //     phone: formData.phone,
    //     message: formData.message,
    //     botcheck: "",
    //   }),
    // });
    // const data = await res.json();
    // if (data.success) {
    //   setSubmitted(true);
    // } else {
    //   setError("Something went wrong. Please try again.");
    // }
  };

  return (
      <section id="contact" className="overflow-hidden py-20 px-6 text-center bg-gradient-to-tr from-pink-100 to-sky-100">
      <h2 className="text-4xl font-bold mb-2">Start Your Career Planning Journey Today</h2>
      <p className="text-lg text-indigo-600 font-semibold mb-4">Book your consultation now</p>
      <p className="max-w-xl mx-auto text-gray-700 mb-4">
        Get in touch for personalized consultations or queries. Our experts are ready to guide you at every stage of your career journey.
      </p>
      <p className="text-lg font-semibold text-gray-800 mb-2">
        📞 Call us: <a href="tel:+919920405421" className="text-indigo-600 hover:underline">+91 9920405421</a>
      </p>
      <p className="text-md text-gray-700 mb-10">
        📧 Email: <a href="mailto:connect@systematiccareerplanner.com" className="text-indigo-600 hover:underline">connect@systematiccareerplanner.com</a>
      </p>
      {!submitted ? (
      <form onSubmit={handleSubmit} className="relative max-w-lg mx-auto bg-white/80 rounded-3xl shadow-xl p-8 space-y-4">
        {/* Honeypot field — hidden from users, catches bots */}
        <input
          type="text"
          name="botcheck"
          value={formData.botcheck}
          onChange={handleChange}
          autoComplete="off"
          className="hidden"
          style={{ display: 'none' }}
        />
        <input type="text" name="name" placeholder="Your Name" required className="w-full px-4 py-3 rounded-lg border focus:ring focus:ring-indigo-200" onChange={handleChange} value={formData.name}/>
        <input type="tel" name="phone" placeholder="Your Phone Number" required pattern="[0-9]{10}" title="Enter a valid 10-digit phone number" className="w-full px-4 py-3 rounded-lg border focus:ring focus:ring-indigo-200" onChange={handleChange} value={formData.phone}/>
        <input type="email" name="email" placeholder="Your Email" required className="w-full px-4 py-3 rounded-lg border focus:ring focus:ring-indigo-200" onChange={handleChange} value={formData.email}/>
        <textarea name="message" placeholder="Your Message" rows="4" required className="w-full px-4 py-3 rounded-lg border focus:ring focus:ring-indigo-200" onChange={handleChange} value={formData.message}></textarea>
        {error && <p className="text-red-600 text-sm">{error}</p>}
        <button type="submit" disabled={loading} className="w-full py-3 rounded-lg bg-indigo-600 text-white hover:scale-105 transition disabled:opacity-50 disabled:cursor-not-allowed">
          {loading ? "Sending..." : "Send Message 🚀"}
        </button>
      </form>
      ) : (
          <div className="bg-green-100 text-green-700 p-6 rounded shadow">Thanks! We'll get back to you soon.</div>
        )}
    </section>
  );
};

export default ContactForm;
